import EdgeCommon from "../edgeCommon";

export default class EdgeProfile extends EdgeCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'edge_profile';
    this.partName = 'Edge Profile';
    this.translateId = "visualizer.kitchen.countertop.edge_profile";
    // this.isStoneFeature = true;
    this.customClassName = "edge";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new EdgeProfile());
  }
}
